import styled, { css } from 'styled-components';
import { xs } from '@exonet/react-shared/lib/styled';

export const Wrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-flow: column nowrap;

  p {
    text-align: center;

    ${xs(css`
      font-size: 1.5em;
    `)}
  }
`;

export const Title = styled.div`
  font-size: 3.2em;
  font-weight: bold;
  text-align: center;
  color: var(--red);
  margin: 0.5em 0;

  ${xs(css`
    font-size: 4.2em;
    margin: 0;
  `)}
`;

export const Description = styled.p`
  margin-bottom: 0;
`;

export const Identifier = styled.div`
  font-style: italic;
  text-align: center;
  font-size: 0.8em;
  margin-bottom: var(--lg-padding-vertical);
  margin-top: var(--xs-padding-vertical);

  ${xs(css`
    font-size: 0.9em;
  `)}
`;

export const Cool = styled.div`
  z-index: var(--base-z-index);
  width: 400px;
  height: 400px;
  margin: 1em auto;
  border-radius: 80%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  background-image: url('/public/images/pagenotfound.gif');
`;
